import React, { useState, useEffect } from 'react';
import axios from 'axios';
export default function FileTree({ rootPath, onSelect }) {
  const [tree, setTree] = useState([]);
  useEffect(() => {
    if (rootPath) axios.get(`/api/files/tree?dir=${rootPath}`).then(res => setTree(res.data));
  }, [rootPath]);
  const renderTree = (nodes) => nodes.map(node => (
    <div key={node.path} className="ml-4">
      {node.isDirectory ? (
        <details>
          <summary className="cursor-pointer hover:text-blue-400">{node.name}/</summary>
          {node.children && renderTree(node.children)}
        </details>
      ) : (
        <div className="cursor-pointer hover:text-blue-400" onClick={() => onSelect(node.path)}>{node.name}</div>
      )}
    </div>
  ));
  return <div className="p-2 text-sm">{renderTree(tree)}</div>;
}
